import React from 'react';

export default function ResultsBlock6Limits() {
  return (
    <section className="py-24 md:py-24 px-6 md:px-16 bg-[#efefff] text-ink" id="contacto">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-24 max-w-4xl mx-auto">
          <div className="text-[12px] font-semibold text-brand tracking-widest uppercase mb-6">
            DISCIPLINA DE EVIDENCIA
          </div>
          <h2 className="text-[32px] md:text-[48px] lg:text-[48px] font-bold mb-8 tracking-tight">
            Medimos lo que podemos demostrar.
          </h2>
          <p className="text-[20px] md:text-[24px] text-ink-soft leading-[1.6]">
            BAC se diseña para operar cobertura, continuidad, cumplimiento operacional y tiempo a resolución. Los resultados clínicos finales requieren evaluación prospectiva.
          </p>
        </div>

        <div className="max-w-4xl mx-auto flex flex-col gap-8 lg:gap-12 mb-20">
          
          {/* Columna A */}
          <div className="w-full bg-[#ccccff] border border-brand/20 rounded-xl p-8 md:p-12 flex flex-col">
            <div className="text-[14px] font-semibold text-brand tracking-widest uppercase mb-8 border-b border-brand/20 pb-4">
              LO QUE SÍ PODEMOS DECIR
            </div>
            <ul className="space-y-6 text-[16px] md:text-[18px] text-ink-soft">
              <li className="flex items-start">
                <span className="text-brand mr-4 mt-1">
                  <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </span>
                <span>La experiencia se desarrolló con datos reales de APS.</span>
              </li>
              <li className="flex items-start">
                <span className="text-brand mr-4 mt-1">
                  <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </span>
                <span>En el piloto preventivo de Paine se observó mayor proporción de hallazgos alterados en el grupo priorizado.</span>
              </li>
              <li className="flex items-start">
                <span className="text-brand mr-4 mt-1">
                  <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </span>
                <span>Se documentó una diferencia en EMPA por hallazgo identificado.</span>
              </li>
              <li className="flex items-start">
                <span className="text-brand mr-4 mt-1">
                  <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </span>
                <span>En el piloto crónico se priorizaron acciones sobre pacientes bajo control, encontrando alteraciones en el 22,2% de la muestra evaluada y generando nuevas reclasificaciones de riesgo.</span>
              </li>
              <li className="flex items-start">
                <span className="text-brand mr-4 mt-1">
                  <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </span>
                <span>La experiencia mostró operacionalmente la necesidad de continuar gestionando la trayectoria posterior.</span>
              </li>
              <li className="flex items-start">
                <span className="text-brand mr-4 mt-1">
                  <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </span>
                <span>La experiencia de YMC que dio origen a BAC ha operado sobre datos provenientes de RAYEN y AVIS.</span>
              </li>
            </ul>
          </div>

        </div>

        {/* CTA */}
        <div className="text-center max-w-3xl mx-auto border-t border-brand/20 pt-20 pb-8">
          <h2 className="text-[32px] md:text-[48px] font-bold mb-6 tracking-tight">
            Conversemos desde la evidencia.
          </h2>
          <p className="text-[16px] md:text-[20px] text-ink-soft mb-10">
            Podemos revisar qué población de tu red necesita operación y qué resultados deberían medirse desde el inicio.
          </p>
          <a href="/#contacto" className="inline-block bg-brand text-white hover:bg-brand-deep hover:text-white px-12 py-3 text-[20px] font-semibold tracking-widest rounded-xl transition-colors uppercase focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand">
            CONVERSEMOS
          </a>
        </div>

      </div>
    </section>
  );
}
